'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Home;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Home() {
  return _react2.default.createElement(
    'div',
    { className: 'Home' },
    _config2.default.app.show.featured && _react2.default.createElement(
      'aside',
      null,
      _react2.default.createElement(_containers.FeaturedListContainer, null)
    ),
    _react2.default.createElement(_containers.EventBrowserContainer, { title: 'Tous les \xE9v\xE9nements' })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home.js
// module id = 1169
// module chunks = 0